/***
 * www.mohela.com TypeScript Entry Point
 * @author Arthur Moore <ArthurMO@mohela.com>
 * @copyright MOHELA 2024
 ***/

import 'vite/modulepreload-polyfill' // Required when using Backend Integration mode
import '@/main.js';
import './app.scss';

import { run } from '@/main.js';

console.log("mohela")
$("#divAnnouncements").dialog({
  dialogClass: "AnnouncementsDialog",
  modal: true,
  autoOpen: false,
  title: "",
  width: "70%",
  maxWidth: 500,
  resizable: false,
  close: () => $('.searchLink').removeClass('hide'),
  position: { my: "center", at: "center", of: window }
});

var hdnAnnouncements = $('[id$="hdnAnnouncements"]');
var hdnAnnouncementsValue = hdnAnnouncements.val();
if (hdnAnnouncementsValue == "N") {
  $('#divAnnouncements').dialog('open');
  $('.searchLink').addClass('hide');
};


$('.AnnouncementsButton').click(function (e) {
  $('#divAnnouncements').dialog('open');
  $('.searchLink').addClass('hide');
  return false;
});
run();
